import React, { PropsWithChildren } from 'react';
import { Panel } from '../panel/Panel';
import styles from './Accordion.module.scss';

export const Accordion = ({ children }: AccordionProps) => (
    <Panel className={styles.default}>
        {children}
    </Panel>
);

export type AccordionProps = PropsWithChildren<Record<never, never>>;